const TEXT_FILTER_KEYS = [
    "name",
    "document",
    "email",
    "holder_name",
    "project_name",
] as const;

function parseQueryFilter(queryFilter: string): URLSearchParams {
    const normalized = queryFilter.startsWith("&")
        ? queryFilter.slice(1)
        : queryFilter;

    return new URLSearchParams(normalized);
}

function matchesTextFilter(
    row: Record<string, unknown>,
    key: string,
    value: string
): boolean {
    const search = value.toLowerCase().trim();
    if (!search) {
        return true;
    }

    const candidates = [
        row[key],
        key === "name" ? row.project_name : undefined,
        key === "project_name" ? row.name : undefined,
        row.holder_name,
        typeof row.holder === "object" && row.holder !== null
            ? (row.holder as { full_name?: string }).full_name
            : undefined,
    ];

    return candidates.some(
        (candidate) =>
            typeof candidate === "string" &&
            candidate.toLowerCase().includes(search)
    );
}

function matchesDateFilter(
    row: Record<string, unknown>,
    startDate?: string | null,
    endDate?: string | null
): boolean {
    if (!startDate && !endDate) {
        return true;
    }

    const rawDate = row.created_at;
    if (typeof rawDate !== "string" || !rawDate) {
        return true;
    }

    const rowDate = rawDate.slice(0, 10);
    if (startDate && rowDate < startDate) {
        return false;
    }
    if (endDate && rowDate > endDate) {
        return false;
    }

    return true;
}

export function applyCustomerFilters<T extends Record<string, unknown>>(
    rows: T[],
    queryFilter: string
): T[] {
    if (!queryFilter) {
        return rows;
    }

    const params = parseQueryFilter(queryFilter);
    const status = params.get("status");
    const startDate = params.get("start_date");
    const endDate = params.get("end_date");

    return rows.filter((row) => {
        if (status !== null && status !== "") {
            const rowStatus = row.customer_status_id;
            if (rowStatus !== undefined && rowStatus !== null) {
                if (String(rowStatus) !== String(status)) {
                    return false;
                }
            }
        }

        const matchesAllTextFilters = TEXT_FILTER_KEYS.every((key) => {
            const value = params.get(key);
            if (!value) {
                return true;
            }
            return matchesTextFilter(row, key, value);
        });
        if (!matchesAllTextFilters) {
            return false;
        }

        if (!matchesDateFilter(row, startDate, endDate)) {
            return false;
        }

        return true;
    });
}
